import React from "react";
import { motion } from "framer-motion";
import "./MenCategory.css";

const CatalogLoadingScreen = ({ subtitle = "Loading collection..." }) => {
  return (
    <div className="men-category-loader">
      <div className="loader-container">
        <div className="loader-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className="loader-text">ASB FASHION</div>
        <div className="loader-bar">
          <motion.div
            className="loader-bar-progress"
            animate={{ width: ["0%", "100%"] }}
            transition={{ duration: 2, repeat: Infinity }}
          />
        </div>
        <p className="loader-subtitle">{subtitle}</p>
      </div>
    </div>
  );
};

export default CatalogLoadingScreen;